/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Popover, PopoverContent, PopoverTrigger } from "@radix-ui/react-popover";
import { countries } from "countries-list";
import { motion } from "framer-motion";
import { memo, useEffect, useState } from "react";
import {
  getLocalStorage,
  removeItemFromLocalStorage,
  removeUserLoginKeyFromLocalStorage,
  setLocalStorage,
} from "~/lib/helperFuncation/localStorageService";
import {
  getforgotPasswordOtpTokenThunk,
  getOtpTokenThunk,
  setError,
  setErrorNull,
  setIsDialogClose,
  setIsDisabledNextButton,
  setIsFirebaseLogin,
  setIsFocus,
  setIsPasswordFalse,
  setIsUserLoginTrue,
  setLoginStep,
  verifyPasswordThunk,
} from "~/lib/store/slice/loginSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { AUTH_COOKIE_TOKEN, RECAPTCHA_TOKEN, TIMER_KEY, USER_COUNTRY, USER_COUNTRY_PHONE_CODE, USER_MOBILE_NUMBER } from "~/utils/constant";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";
import { ComponentHeader, InputComponent, LoginFlowButton, LoginResponseErrorComponent } from "./Login";
// libphonenumber import
import { zodResolver } from "@hookform/resolvers/zod";
import pkg from "google-libphonenumber";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { toast } from "sonner";
import { useFontStyle } from "~/hook/useFontStyle";
import useLocale from "~/hook/useLocale";
import { LoginPassword } from "~/interface/login/login";
import { getFirebaseMessaging } from "~/lib/firebase/firebase.client";
import { getSession, removeSession, setSession } from "~/lib/helperFuncation/sessionStorageService";
import { cn } from "~/lib/utils";
import { getPhoneLengthForCountry, LoginWithPasswordSchema, validatePhoneForCountry } from "~/scheme/loginSchema";
import { setCookie } from "~/utils/cookies";
import { getExpiryFromToken } from "~/utils/jwt";
import ReCaptchaV2 from "../shared-components/ReCaptcha";
import { useFirebaseOTPSender } from "./FirebaseAuthIntegration";

const { PhoneNumberUtil } = pkg;

const phoneUtil = PhoneNumberUtil.getInstance();

// Create countryPhoneCodeMap from countries
const countryPhoneCodeMap: { [phoneCode: string]: string } = {};
Object.entries(countries).forEach(([code, data]) => {
  const phone = Array.isArray(data.phone) ? data.phone[0] : data.phone;
  if (phone && !countryPhoneCodeMap[phone]) {
    countryPhoneCodeMap[phone] = code;
  }
});

const DEFAULT_VALUE = {
  password: "",
};

const LoginMobileNumber = () => {
  const { t } = useTranslation();
  const { normalInter } = useFontStyle();
  const { error, isPassword, navigatTo, isFirebaseLogin } = useAppSelector((state) => state.login);
  const [userCountryPhone, setUserCountrySelectePhone] = useState<number>(91);
  const [userMobileNumber, setUserMobileNumber] = useState<string>("");
  const [invalidNumber, setIsInvalidNumber] = useState(false);
  const { LocalizedLink } = useLocale();
  const navigate = useNavigate();

  const location = useLocation().pathname;

  // const { executeRecaptcha } = useGoogleReCaptcha();
  const [captchaToken, setCaptchaToken] = useState<string | null>(getSession(RECAPTCHA_TOKEN) || null);

  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<LoginPassword>({
    mode: "onSubmit",
    resolver: zodResolver(LoginWithPasswordSchema),
    defaultValues: {
      mobile: getLocalStorage(USER_MOBILE_NUMBER) || "",
      password: "",
    },
  });

  const mobile_number = watch("mobile");

  // Firebase OTP sender hook - must be after watch is defined
  const firebaseOTP = useFirebaseOTPSender({
    phoneNumber: mobile_number || "",
    countryCode: userCountryPhone,
    recaptchaToken: captchaToken,
    onFirebaseSuccess: (msg) => console.log(msg),
    onFirebaseError: (err) => dispatch(setError(err)),
  });

  const countryList = Object.entries(countries).map(([code, data]) => ({
    name: data.name,
    code,
    phone: data.phone[0],
  }));

  const validateNumber = (number: string, countryCode: string): boolean => {
    try {
      const parsed = phoneUtil.parse(number, countryCode);
      return phoneUtil.isValidNumber(parsed);
    } catch (e) {
      return false;
    }
  };

  const initPush = async () => {
    try {
      const messaging = await getFirebaseMessaging(dispatch);
      if (!messaging) return;

      console.log("Firebase messaging initialized");
    } catch (err) {
      console.error("FCM init error:", err);
    }
  };

  const onSubmit = async (data: LoginPassword) => {
    const regionCode = countryPhoneCodeMap[userCountryPhone];
    const fullNumber = data.mobile;
    const isIndia = userCountryPhone === 91;
    // const isIndia = false;

    if (isPassword) {
      if (!data.password) {
        dispatch(setError("Password is required"));
        return;
      }

      try {
        const payload = {
          password: data.password!,
          mobile: fullNumber,
          country_code: userCountryPhone.toString(),
        };

        const response = await dispatch(verifyPasswordThunk(payload)).unwrap();

        if (response.contenttoken) {
          const token = response.contenttoken || "";
          const expiry = getExpiryFromToken(token);
          const maxAge = expiry && expiry > Date.now() ? Math.floor((expiry - Date.now()) / 1000) : 60 * 60 * 24;

          // content token, use it
          const contentToken = response?.bhaktiToken || "";
          const contentExpiry = getExpiryFromToken(contentToken);
          const contentMaxAge = contentExpiry && contentExpiry > Date.now() ? Math.floor((contentExpiry - Date.now()) / 1000) : 60 * 60 * 24;

          // Set auth token in cookies
          setCookie(AUTH_COOKIE_TOKEN, token, {
            path: "/", // cookie available across the site
            expires: maxAge, // cookie expiry (in seconds)
            secure: false, // only over HTTPS
            sameSite: "lax", // CSRF protection
          });

          // Set content token if available
          // setCookie(CONTENT_TOKEN, contentToken, {
          //   path: "/", // cookie available across the site
          //   expires: contentMaxAge, // cookie expiry (in seconds)
          //   secure: false, // only over HTTPS
          //   sameSite: "lax", // CSRF protection
          // });

          dispatch(setIsUserLoginTrue());
          setCaptchaToken(null);
          navigate(navigatTo ?? `${location}`);
          initPush();

          toast.success("Login Successfully");
          if (!("Notification" in window)) return;
          // request permission (optional if already done)
          Notification.requestPermission();
        }
      } catch (err) {
        console.error("Password verification error:", err);
        toast.error("Login Failed");
      }
      return;
    } else {
      // Validate phone number based on selected country
      const validation = validatePhoneForCountry(fullNumber, userCountryPhone);
      if (!validation.valid) {
        console.warn("Invalid phone number:", validation.message);
        setIsInvalidNumber(true);
        dispatch(setError(validation.message));
        return;
      }

      setIsInvalidNumber(false);
      if (!captchaToken) {
        console.warn("Captcha token missing");
        toast.error("Please verify that you are not a robot");
        dispatch(setError("Please verify that you are not a robot"));
        return;
      }

      // India: Use backend OTP authentication

      if (isIndia) {
        dispatch(setIsFirebaseLogin(false));
        console.log(" In Sending Backend OTP for India");
        dispatch(setError("")); // Clear any previous errors
        const resp = await dispatch(getOtpTokenThunk({ mobile: fullNumber, recaptchaToken: captchaToken, country_code: userCountryPhone }));
        if (getOtpTokenThunk.fulfilled.match(resp)) {
          setCaptchaToken(null);
        }
      } else {
        // Other countries: Use Firebase OTP authentication

        dispatch(setIsFirebaseLogin(true));
        dispatch(setError(""));

        try {
          const firebaseSuccess = await firebaseOTP.sendOTP();
          console.log("Firebase OTP result:", firebaseSuccess);

          if (firebaseSuccess) {
            setCaptchaToken(null);
          }
        } catch (error) {
          console.error("❌ Firebase OTP exception:", error);
          const errorMessage = error instanceof Error ? error.message : "Firebase OTP failed";
          dispatch(setError(`Firebase error: ${errorMessage}. Falling back to backend OTP...`));
        }
      }
    }
  };

  const handleOnForgotPassword = async () => {
    const mobile = getLocalStorage(USER_MOBILE_NUMBER);
    const country_code = getLocalStorage(USER_COUNTRY_PHONE_CODE);
    if (!captchaToken) {
      toast.error("Please verify that you are not a robot");
      return;
    }

    // if (!executeRecaptcha) {
    //   dispatch(setError("Recaptcha not yet available, Please try agin"));
    //   return;
    // }
    // const token = await executeRecaptcha("forgot");

    await dispatch(getforgotPasswordOtpTokenThunk({ mobile, country_code, recaptchaToken: captchaToken }));
  };

  const handleOnNavigate = () => {
    dispatch(setIsDialogClose());
    removeUserLoginKeyFromLocalStorage();
    dispatch(setErrorNull());
    dispatch(setLoginStep(1));
    dispatch(setIsPasswordFalse());
    removeItemFromLocalStorage(TIMER_KEY);
    removeItemFromLocalStorage(USER_MOBILE_NUMBER);
  };

  useEffect(() => {
    //first time if user from india
    setLocalStorage(USER_COUNTRY_PHONE_CODE, "91");

    const savedCountryPhoneCode = getLocalStorage(USER_COUNTRY_PHONE_CODE) || "91";
    const savedMobileNumber = getLocalStorage(USER_MOBILE_NUMBER) || "";

    // Convert string to number for proper comparison
    const phoneCodeAsNumber = parseInt(savedCountryPhoneCode, 10) || 91;

    setUserCountrySelectePhone(phoneCodeAsNumber);
    setUserMobileNumber(savedMobileNumber);

    console.log("Auth method initialized with country code:", phoneCodeAsNumber);

    return () => {
      setCaptchaToken(null);
      removeSession(RECAPTCHA_TOKEN);
    };
  }, []);

  useEffect(() => {
    if (mobile_number.length === 0) {
      dispatch(setIsPasswordFalse());
      dispatch(setIsDisabledNextButton(true));
      return;
    }

    // Get valid phone length range for selected country
    const phoneLengths = getPhoneLengthForCountry(userCountryPhone);
    const numberLength = mobile_number.length;

    // Check if phone number length is valid for the selected country
    const isValidLength = numberLength >= phoneLengths.min && numberLength <= phoneLengths.max;

    if (!isValidLength) {
      dispatch(setIsPasswordFalse());
      dispatch(setIsDisabledNextButton(true));
    } else if (isValidLength && captchaToken) {
      dispatch(setIsDisabledNextButton(false));
    } else {
      dispatch(setIsDisabledNextButton(true));
    }
  }, [mobile_number, userCountryPhone, captchaToken, dispatch]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-full h-full flex flex-col justify-start md:justify-center items-start gap-4 ">
      {/* <ReCaptcha getCaptchaToken={onVerify} /> */}
      <div className="w-full rounded-full flex justify-center md:hidden mb-4">
        <div className="w-[40%] aspect-square">
          <img src="/images/maharaj-header-icon.webp" alt="swaminarayan bhagawan" className="w-full h-full select-none" />
        </div>
      </div>
      <ComponentHeader title={t("login_page.title")} text={t("login_page.subtitle")} />
      {error && <LoginResponseErrorComponent />}
      {/* Auth method indicator - shows based on selected country
      <div className={cn("w-full px-3 py-2 rounded-md text-sm font-inter text-center", 
        userCountryPhone === 91 
          ? "bg-blue-50 border border-blue-200 text-blue-700" 
          : "bg-orange-50 border border-orange-200 text-orange-700"
      )}>
        {userCountryPhone === 91 
          ? "✓ OTP Authentication (Backend)" 
          : "🔥 Firebase Phone Authentication"}
      </div> */}
      <div className="w-full flex flex-col justify-between items-center gap-4">
        <div className="w-full flex justify-start items-center gap-3 bg-secondaryBackground p-3 rounded-md !z-50 relative">
          <Popover modal={false} open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <div
                className="pr-2 border-r-[1px] border-borderPrimary text-14 text-textColor font-inter font-normal cursor-pointer relative"
                onClick={() => setOpen(!open)}
              >
                +{userCountryPhone}
              </div>
            </PopoverTrigger>
            <PopoverContent align="start" sideOffset={4} className="w-[350px] p-0 bg-white shadow-md pointer-events-auto mt-2">
              <Command className="bg-secondaryBackground">
                <CommandInput
                  placeholder="Search Country"
                  className="placeholder:text-textColor font-inter font-normal text-14 pointer-events-auto outline-none focus-visible:border-none focus-visible:outline-none text-textColor"
                />
                <CommandList className="w-full overflow-y-auto max-h-[250px]">
                  <CommandEmpty className="w-full p-2">No country found.</CommandEmpty>
                  <CommandGroup className="w-full">
                    {countryList.map((country) => (
                      <CommandItem
                        key={country.code}
                        value={country.name}
                        onSelect={(currentValue) => {
                          const phoneCodeAsNumber = typeof country.phone === "string" ? parseInt(country.phone, 10) : country.phone;
                          setUserCountrySelectePhone(phoneCodeAsNumber);
                          setLocalStorage(USER_COUNTRY, country.name);
                          setLocalStorage(USER_COUNTRY_PHONE_CODE, phoneCodeAsNumber.toString());
                          setOpen(false);
                          console.log("Country selected, auth method:", phoneCodeAsNumber === 91 ? "Backend OTP" : "Firebase OTP");
                        }}
                        className="hover:bg-primary cursor-pointer"
                      >
                        <span
                          className={cn("w-[15%] border-r-[1px] border-r-borderPrimary text-14 text-textColor font-inter font-normal", normalInter)}
                        >
                          +{country.phone}
                        </span>
                        <span className={cn("text-14 text-textColor font-inter font-normal", normalInter)}>{country.name}</span>
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </CommandList>
              </Command>
            </PopoverContent>
          </Popover>
          <div className="w-full space-y-0.5">
            <Controller
              control={control}
              name="mobile"
              render={({ field: { onChange, value } }) => {
                const phoneLengths = getPhoneLengthForCountry(userCountryPhone);
                return (
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={phoneLengths.max}
                    value={value}
                    onChange={(e) => {
                      const cleaned = e.target.value.replace(/\D/g, "");
                      onChange(cleaned);
                      setLocalStorage(USER_MOBILE_NUMBER, cleaned);
                    }}
                    onFocus={() => setIsFocus(true)}
                    className={cn(
                      "w-full bg-transparent focus:ring-0 outline-none  text-14 text-textColor  placeholder:text-textColor placeholder:py-2",
                      normalInter,
                    )}
                    placeholder={t("login_page.mobile_placeholder")}
                  />
                );
              }}
            />
          </div>
        </div>
        {errors.mobile && <p className="text-sm text-red-600 w-full text-left">{errors.mobile.message}</p>}
      </div>
      {isPassword && mobile_number && (
        <motion.div
          key="password"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.3 }}
          className="w-full"
        >
          <div className="w-full h-full flex flex-col justify-center items-center gap-6 relative rounded-lg">
            <div className="w-full space-y-1">
              <div className="w-full space-y-0.5">
                <Controller
                  control={control}
                  name="password"
                  render={({ field: { onChange, value } }) => (
                    <InputComponent
                      type="password"
                      className="!rounded-lg"
                      value={value ?? ""}
                      onChange={onChange}
                      label={t("login_page.enter_password")}
                    />
                  )}
                />
                {errors.password && <p className="text-sm text-red-600">{errors.password.message}</p>}
              </div>
              <div className="w-full flex justify-end items-center ">
                <span className="text-14 text-textHeadingColor font-inter font-normal cursor-pointer" onClick={handleOnForgotPassword}>
                  {t("login_page.forgot_password")}
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      {!isPassword && (
        <div className="mx-auto">
          <ReCaptchaV2
            onChange={(recaptchaToken) => {
              setCaptchaToken(recaptchaToken);
              setSession(RECAPTCHA_TOKEN, String(recaptchaToken));
              if (recaptchaToken) {
                dispatch(setIsDisabledNextButton(false));
              }
            }}
          />
        </div>
      )}
      <motion.div
        initial={{ y: 0 }}
        animate={{ y: isPassword ? 10 : 0 }}
        transition={{ duration: 0.3 }}
        className="w-full flex flex-col justify-center items-center gap-3"
      >
        <LoginFlowButton text={isPassword ? t("login_page.login") : t("login_page.next_button")} />

        <div className="w-full flex justify-center items-center gap-2 capitalize ">
          <LocalizedLink to={"/policy/privacy-policy"} className={cn("text-textColor", normalInter)}>
            <span onClick={handleOnNavigate} className="text-14">
              {t("login_page.privacy_policy")}
            </span>
          </LocalizedLink>
          <div className="size-[5px] rounded-full bg-lightbackground"></div>
          <LocalizedLink to={"/policy/terms-condition"} className={cn("text-textColor", normalInter)}>
            <span onClick={handleOnNavigate} className="text-14">
              {t("login_page.terms_and_conditions")}
            </span>
          </LocalizedLink>
          <div className="size-[5px] rounded-full bg-lightbackground"></div>
          <LocalizedLink to={"/policy/disclaimer"} className={cn("text-textColor", normalInter)}>
            <span onClick={handleOnNavigate} className="text-14">
              {t("login_page.disclaimer")}
            </span>
          </LocalizedLink>
        </div>
      </motion.div>
    </form>
  );
};

export default memo(LoginMobileNumber);
